import React from 'react';
import { Link } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import auth from '../auth';
import { limpiarAvisoSesionVencida } from '../api';

const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};
const deleteCookie = (name) => setCookie(name, "", -10);
const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MapPinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);
const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>
  </svg>
);
const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);
const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);
const PipeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 8h9a3 3 0 0 1 3 3 3 3 0 0 0 3 3h3"/><circle cx="6" cy="16" r="2"/><path d="M8 16h6"/>
  </svg>
);

export default function SignIn(props) {
  const [showPassword, setShowPassword] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [rememberChecked, setRememberChecked] = React.useState(false);
  const [user, setUser] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [disconnected, setDisconnected] = React.useState(false);
  const [sesionVencida, setSesionVencida] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_GET_TOKEN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: user, password }),
    }).then((result) => {
      if (result.ok) {
        result.json().then(data => {
          if (rememberChecked) setCookie('asa_hd_lu', user);
          else deleteCookie('asa_hd_lu');
          setCookie('asa_hd_auth', data.token, 1 / 24 / 2);
          auth.login(() => props.history.push('/home'));
        });
      } else {
        setOpen(true);
      }
    }).catch(() => setDisconnected(true));
  };

  React.useEffect(() => {
    // api.js redirige aca con ?sesion=vencida cuando caduca el token. El aviso
    // se muestra al llegar, en vez de un alert() bloqueante antes de navegar.
    if (new URLSearchParams(window.location.search).get('sesion') === 'vencida') {
      setSesionVencida(true);
      limpiarAvisoSesionVencida();
      window.history.replaceState({}, '', window.location.pathname);
    }

    const lastUser = getCookie('asa_hd_lu');
    const userToken = getCookie('asa_hd_auth');
    if (lastUser) { setUser(lastUser); setRememberChecked(true); }
    if (userToken) {
      fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_VALIDATE_TOKEN, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${userToken}` },
        body: JSON.stringify({}),
      }).then(result => {
        if (result.ok) auth.login(() => props.history.push('/home'));
      });
    }
  }, []);

  return (
    <div className="ds-auth-shell">
      <div className="ds-auth-body">
        {/* Navy aside */}
        <div className="ds-auth-aside">
          <div className="ds-auth-glow" />
          <div className="ds-brand">
            <div className="ds-brand-mark"><PipeIcon /></div>
            <div className="ds-brand-titles">
              <div className="ds-brand-t1">Oldelval <span className="light">· App Externos</span></div>
              <div className="ds-brand-t2">Portal de <b>Solicitudes de Interferencias</b></div>
            </div>
          </div>
          <div style={{ position: 'relative' }}>
            <h2>Gestioná tus cruces sobre la traza de Oldelval</h2>
            <p>Presentá solicitudes de interferencia, seguí su evaluación técnica y legal, y cargá tu documentación desde un solo lugar.</p>
          </div>
          <div className="ds-auth-feats">
            <div className="ds-auth-feat">
              <div className="ic"><MapPinIcon /></div>
              <div className="tx"><b>Dibujá la interferencia</b><span>Mapa, carga de KML/KMZ y coordenadas DMS.</span></div>
            </div>
            <div className="ds-auth-feat">
              <div className="ic"><ClockIcon /></div>
              <div className="tx"><b>Seguí el estado en vivo</b><span>Sabé en qué etapa está cada solicitud.</span></div>
            </div>
            <div className="ds-auth-feat">
              <div className="ic"><ShieldIcon /></div>
              <div className="tx"><b>Documentación segura</b><span>Técnica, legal y CAO en un flujo guiado.</span></div>
            </div>
          </div>
        </div>

        {/* Form column */}
        <div className="ds-auth-form-col">
          <div className="ds-auth-form">
            <h1>Iniciar sesión</h1>
            <div className="ds-auth-sub">Ingresá con tu CUIT o email para continuar.</div>
            <form onSubmit={handleSubmit} noValidate>
              <div className="ds-form-rows">
                <div className="ds-field">
                  <label>CUIT / Email</label>
                  <input
                    className={`ds-input${open ? ' err' : ''}`}
                    type="text"
                    value={user}
                    onChange={e => { setUser(e.target.value); setOpen(false); }}
                    placeholder="Tu CUIT o correo electrónico"
                    autoComplete="username"
                    autoFocus
                  />
                </div>
                <div className="ds-field">
                  <label>Contraseña</label>
                  <div className="ds-input-wrap">
                    <input
                      className={`ds-input${open ? ' err' : ''}`}
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={e => { setPassword(e.target.value); setOpen(false); }}
                      placeholder="••••••••"
                      autoComplete="current-password"
                    />
                    <button type="button" className="ds-input-trail" onClick={() => setShowPassword(v => !v)}>
                      {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                  </div>
                  {open && <div className="ds-helper err">CUIT/email o contraseña incorrectos.</div>}
                </div>
                <label className="ds-checkbox-label">
                  <input type="checkbox" checked={rememberChecked} onChange={e => setRememberChecked(e.target.checked)} />
                  Recordarme en este equipo
                </label>
                <button type="submit" className="ds-btn ds-btn-primary ds-btn-block ds-btn-lg">
                  Iniciar sesión
                </button>
              </div>
            </form>
            <div className="ds-auth-links">
              <Link to="/resetPassword">¿Olvidaste tu contraseña?</Link>
              <Link to="/register">Crear cuenta</Link>
            </div>
          </div>
        </div>
      </div>

      <Snackbar open={disconnected} autoHideDuration={6000} onClose={() => setDisconnected(false)}>
        <Alert onClose={() => setDisconnected(false)} severity="error" sx={{ width: '100%' }}>
          Sin conexión con el servidor.
        </Alert>
      </Snackbar>

      <Snackbar open={sesionVencida} autoHideDuration={8000} onClose={() => setSesionVencida(false)}>
        <Alert onClose={() => setSesionVencida(false)} severity="warning" sx={{ width: '100%' }}>
          Tu sesión caducó. Ingresá de nuevo para continuar.
        </Alert>
      </Snackbar>
    </div>
  );
}
